import { Injectable, OnInit, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LoginService{
  private loggedIn = new BehaviorSubject<boolean>(false);
  loggedInuser: string = "";
  route: ActivatedRoute = inject(ActivatedRoute);

  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }
  logged(): boolean {
    return this.loggedIn.value;
  }
  constructor(private router: Router) { }
  
  login(userName: string, password: string){
    console.log(`LoginService::login(${userName}, ${password})`);
    if (userName !== "" && password !== "" && userName == "a" && password == "a"){
      this.loggedIn.next(true);
      this.loggedInuser = userName;
      this.router.navigate(['/']);
    } else {
      let errorMessage: string = "Usuario y/o contraseña invalidos";
      console.log(errorMessage);
      errorMessage = errorMessage
      .replaceAll('(', '')
      .replaceAll(')', '')
      .replaceAll('/', '');
      var url = 'login/' + errorMessage;
      console.log(`Redirigiendo a ${url}`)
      this.router.navigate([url]);
    }
  }
  logout(): void {
    this.loggedIn.next(false);
    this.loggedInuser="";
    this.router.navigate(["/login"]);
  }
}
